/*global Modernizr, flatpickr, tns */
/*jslint browser:true */

(function() {
  'use strict';

  var header_container = document.querySelector('header');
  document.addEventListener('scroll', () => {
    checkScrollStatus();
  });

  checkScrollStatus();
  setTimeout(() => {
    header_container.classList.remove('notransition');
  }, 400);

  function checkScrollStatus() {
    if(window.scrollY > 10 && !header_container.classList.contains('scrolled')) {
      header_container.classList.add('scrolled');
    } else if(window.scrollY <= 10) {
      header_container.classList.remove('scrolled');
    }
  }

  var search_trigger = header_container.querySelector('.search-trigger');
  search_trigger.addEventListener('click', (e) => {
    e.preventDefault();

    document.querySelector('body').classList.remove('nav-open');
    header_container.classList.add('searching');
    header_container.querySelector('.search-container input').focus();
  });

  var search_close_trigger = header_container.querySelector('.search-close');
  search_close_trigger.addEventListener('click', (e) => {
    e.preventDefault();

    header_container.querySelector('.autocomplete-results').classList.remove('open');

    document.querySelector('body').classList.remove('nav-open');
    header_container.classList.remove('searching');
  });

  var mobile_menu_trigger = header_container.querySelector('.mobile-menu-trigger');
  if(mobile_menu_trigger) {
    mobile_menu_trigger.addEventListener('click', (e) => {
      e.preventDefault();

      header_container.classList.remove('searching');
      document.querySelector('body').classList.toggle('nav-open');
    });

    var body_container = document.querySelector('.body-container');
    if(body_container) {
      body_container.addEventListener('click', (e) => {
        if(document.querySelector('body').classList.contains('nav-open')) {
          e.preventDefault();

          document.querySelector('body').classList.remove('nav-open');
        }
      });
    }
  }

  var input_containers = document.querySelectorAll('.input-container input');
  if(input_containers) {
    input_containers.forEach((input_container_input) => {
      if(input_container_input.value !== '') {
        input_container_input.classList.add('has-value');
      } else {
        input_container_input.classList.remove('has-value');
      }

      input_container_input.addEventListener('change', () => {
        if(input_container_input.value !== '') {
          input_container_input.classList.add('has-value');
        } else {
          input_container_input.classList.remove('has-value');
        }
      });
    });
  }

  var datepickers = document.querySelectorAll('.js-datepicker');
  if(datepickers) {
    datepickers.forEach((datepicker) => {
      var picker = new flatpickr(datepicker, {
        mode: "range",
        dateFormat: "m-d-Y"
      });
    });
  }

  var hero_slideshow = document.querySelector('.block-slideshow.hero');
  if(hero_slideshow) {
    var slideshow_guides = document.querySelectorAll('.block-slideshow-guide > a'),
        controls_pause = hero_slideshow.querySelector('.pause'),
        controls_play = hero_slideshow.querySelector('.play'),
        slider = tns({
          container: hero_slideshow.querySelector('.slides'),
          items: 1,
          autoplay: true,
          autoplayTimeout: 10000,
          autoplayButtonOutput: false,
          controls: false,
          nav: false,
          autoHeight: true
        });

    slider.events.on('indexChanged', (info, eventName) => {
      document.querySelector('.block-slideshow-guide a.current').classList.remove('current');
      slideshow_guides[info.displayIndex - 1].classList.add('current');
    });

    slideshow_guides.forEach((slideshow_slide, i) => {
      slideshow_slide.addEventListener('click', (e) => {
        e.preventDefault();

        if(!slideshow_slide.classList.contains('current')) {
          slider.goTo(i);
        }
      });
    });

    controls_pause.addEventListener('click', (e) => {
      e.preventDefault();

      slider.pause();
      hero_slideshow.classList.remove('status-play');
      hero_slideshow.classList.add('status-pause');
    });

    controls_play.addEventListener('click', (e) => {
      e.preventDefault();

      slider.play();
      hero_slideshow.classList.remove('status-pause');
      hero_slideshow.classList.add('status-play');
    });
  }

  var slideshow_videos = document.querySelectorAll('.block-slideshow-video');
  if(slideshow_videos) {
    slideshow_videos.forEach((slideshow_video) => {
      var slider_controls = slideshow_video.querySelector('.nav-controls'),
          slider_previous = slider_controls.querySelector('.slide-previous'),
          slider_next = slider_controls.querySelector('.slide-next'),
          slide_index = slider_controls.querySelector('.slide-status .current'),
          slides = slideshow_video.querySelectorAll('.slides .slide'),
          slider = tns({
            container: slideshow_video.querySelector('.slides'),
            items: 1,
            controls: false,
            nav: false
          });

      if(slides.length > 1) {
        slider_controls.querySelector('.slide-status .count').textContent = slides.length;
        slider_controls.classList.remove('hide');
      }

      slider.events.on('indexChanged', (info, eventName) => {
        slide_index.textContent = info.displayIndex;
      });

      slider_previous.addEventListener('click', (e) => {
        e.preventDefault();
        slider.goTo('prev');
      });

      slider_next.addEventListener('click', (e) => {
        e.preventDefault();
        slider.goTo('next');
      });
    });
  }

  var accordions = document.querySelectorAll('.accordion-title');
  if(accordions) {
    accordions.forEach((accordion) => {
      accordion.addEventListener('click', (e) => {
        e.preventDefault();
        accordion.parentNode.classList.toggle('open');
      });
    });
  }

  var tabs_container = document.querySelectorAll('.block-tabs');
  tabs_container.forEach((tab_container) => {
    var current_tab_indicator = tab_container.querySelector('.current-tab'),
        tabs = tab_container.querySelectorAll('ul a'),
        tabs_contents = tab_container.nextElementSibling.children;

    changeTab(tab_container, 0);

    current_tab_indicator.addEventListener('click', (e) => {
      e.preventDefault();

      tab_container.classList.toggle('open');
    });

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', (e) => {
        e.preventDefault();

        tab_container.classList.remove('open');
        changeTab(tab_container, index);
      });
    });

    Array.from(tabs_contents).forEach((tabs_content, index) => {
      tabs_content.addEventListener('focusin', () => {
        changeTab(tab_container, index);
      });
    });
  });

  function changeTab(tab_container, tab_index) {
    var current_tab_indicator = tab_container.querySelector('.current-tab'),
        tabs = tab_container.querySelectorAll('ul a'),
        tab_indicator = tab_container.querySelector('.block-tabs-indicator'),
        tabs_contents = tab_container.nextElementSibling.children;

    if(!tabs[tab_index].classList.contains('active')) {
      if(tab_container.querySelector('.active')) {
        tab_container.querySelector('.active').classList.remove('active');
        tab_container.nextElementSibling.querySelector('.active').classList.remove('active');
      }

      var current_tab = tabs[tab_index],
          offsets = current_tab.getBoundingClientRect();

      current_tab_indicator.querySelector('span').textContent = current_tab.textContent;

      tab_indicator.setAttribute('style', 'left: ' + offsets.left + 'px;width: ' + current_tab.offsetWidth + 'px;');
      tabs[tab_index].classList.add('active');
      tabs_contents[tab_index].classList.add('active');
    }
  }

  var artist_read_more = document.querySelector('.js-artist-readmore');
  if(artist_read_more) {
    artist_read_more.addEventListener('click', (e) => {
      e.preventDefault();

      var tab_container = tabs_container[0],
          tabs = tab_container.querySelectorAll('ul a'),
          tab_bio = tab_container.querySelector('ul a[data-tab="tab-full-bio"]'),
          tab_bio_index = [].indexOf.call(tabs, tab_bio),
          viewportOffset = tab_container.getBoundingClientRect();

      console.log(tab_bio_index);
      changeTab(tab_container, tab_bio_index);
      window.scroll({
        top: viewportOffset.top - 70,
        left: 0,
        behavior: 'smooth'
      });
    });
  }

  var newwindow = document.querySelectorAll('.js-newwindow');
  if(newwindow) {
    newwindow.forEach((newwindow_block) => {
      var block_links = newwindow_block.querySelectorAll('a[href^="http"]');
      block_links.forEach((block_link) => {
        block_link.setAttribute('target', '_blank');
      });
    });
  }
}());
